import { render, staticRenderFns } from "./ProtocolloUtentiListComponent.vue?vue&type=template&id=342151f6"
import script from "./ProtocolloUtentiListComponent.vue?vue&type=script&lang=js"
export * from "./ProtocolloUtentiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports